import React, { useEffect, useState } from "react";
import { Form } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { getGroupCompleted, assignMSAClassTeacher } from "../../../reducers/groups/actions";
import { getTeacherTariffs } from "../../../reducers/teachers/actions";
import * as Actions from "../../../reducers/schedule/actions";
import EditTeacherAssignationForm from "../EditTeacherAssignationForm";
import moment from 'moment';

import "./EditTeacherAsignationModal.scss";

function EditTeacherAsignationModal(props) {

  const {
    groupsReducer,
    classReducer,
    getGroupCompleted,
    getTeacherTariffs,
    startDate,
    match: { params },
  } = props;

  const { group } = groupsReducer;
  const { groupStudyPlan } = classReducer;
  const { id: groupNID } = params;

  const [values, setValues] = useState({
    start_date: moment(startDate, 'DD-MM-YYYY'),
    end_date: moment(startDate, 'DD-MM-YYYY'),
    tariff: group?.tariff_teacher || null,
  });

  const [form] = Form.useForm();

  useEffect(() => {
    groupNID && getGroupCompleted(groupNID);
  }, [groupNID, getGroupCompleted]);

  useEffect(() => {
    getTeacherTariffs();
  }, [getTeacherTariffs]);

  useEffect(() => {
    form.setFieldsValue({
      start_date: moment(startDate, 'DD-MM-YYYY'),
      end_date: moment(startDate, 'DD-MM-YYYY'),
      tariff: group?.tariff_teacher || null,
    });
  }, [group, form, startDate]);

  return (
    <EditTeacherAssignationForm
      {...props}
      group={group}
      groupStudyPlan={groupStudyPlan}
      form={form}
      values={values}
      setValues={setValues}
      groupNID={groupNID}
    />
  );
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...Actions, getGroupCompleted, assignMSAClassTeacher, getTeacherTariffs }, dispatch);
const mapStateToProps = (state) => ({
  groupsReducer: state.get("groupsReducer"),
  classReducer: state.get("classReducer"),
  teachersReducer: state.get("teachersReducer"),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditTeacherAsignationModal);
